import * as React from "react";
export class DateCarouselItem extends React.PureComponent {
    render() {
        const itemClass = "rj-carousel-item" + (this.props.isSelected ? " rj-carousel-item--active" : "");
        return (React.createElement("div", { className: itemClass, onClick: this.props.handler, "data-uat": "carousel-item-date" },
            React.createElement("div", { className: "rj-carousel-item__details" },
                React.createElement("div", { className: "rj-carousel-item__day" }, this.props.item.dayOfWeek),
                React.createElement("div", { className: "rj-carousel-item__date" }, this.props.item.formattedDate))));
    }
}
//# sourceMappingURL=DateCarouselItem.js.map